// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.business-page.staff-plans-page {
  max-width: 960px;
  padding-top: 12px;
}
.business-page.staff-plans-page .business-back {
  font-size: 12px;
  line-height: 18px;
}
.business-page.staff-plans-page > h1 {
  font-size: clamp(23px, 4vw, 28px);
  margin: 8px 0 12px;
  letter-spacing: -0.03em;
}
.business-page.staff-plans-page .business-subtitle {
  display: none;
}
.business-page.staff-plans-page .staff-plans-icon-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  padding: 0;
  border: 1px solid #e1e6ef;
  border-radius: 10px;
  background: #fff;
  color: #637089;
}
.business-page.staff-plans-page .staff-plans-period {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}
.business-page.staff-plans-page .staff-plans-period label {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #78849a;
}
.business-page.staff-plans-page .staff-plans-period input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  min-height: 44px;
  box-sizing: border-box;
  font-size: 16px;
  padding: 8px 10px;
}
.business-page.staff-plans-page .business-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 0;
}
.business-page.staff-plans-page .business-metric {
  min-width: 0;
  padding: 10px;
  border-radius: 12px;
  gap: 5px;
}
.business-page.staff-plans-page .business-metric > span {
  font-size: 11px;
  line-height: 1.3;
}
.business-page.staff-plans-page .business-metric > strong {
  font-size: clamp(16px, 2.6vw, 21px);
  line-height: 1.3;
  letter-spacing: -0.03em;
  font-variant-numeric: tabular-nums;
  overflow-wrap: anywhere;
}
.business-page.staff-plans-page .staff-plans-balance {
  margin: 6px 0 12px;
  color: #78849a;
  font-size: 11px;
  line-height: 1.4;
}
.business-page.staff-plans-page .staff-plans-distribution {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 12px;
  margin-bottom: 12px;
}
.business-page.staff-plans-page .staff-plans-distribution button {
  min-height: 44px;
  font-size: 13px;
  padding: 8px 12px;
}
.business-page.staff-plans-page .staff-plans-distribution small {
  font-size: 11px;
  line-height: 1.4;
}
.business-page.staff-plans-page .business-card {
  min-width: 0;
  padding: 12px;
  margin-bottom: 8px;
  border-radius: 14px;
}
.business-page.staff-plans-page .business-card h2 {
  margin: 0 0 8px;
  font-size: 16px;
  line-height: 1.35;
  overflow-wrap: anywhere;
}
.business-page.staff-plans-page .staff-plan-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
}
.business-page.staff-plans-page .staff-plan-heading > div {
  min-width: 0;
  flex: 1 1;
}
.business-page.staff-plans-page .staff-plan-heading h2 {
  margin: 0 0 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.business-page.staff-plans-page .staff-plan-heading p {
  margin: 0;
  color: #78849a;
  font-size: 11px;
  line-height: 1.4;
}
.business-page.staff-plans-page .staff-plan-card .business-metric {
  padding: 0;
  border: none;
  border-radius: 0;
  background: none;
}
.business-page.staff-plans-page .staff-plan-gap {
  padding: 8px 10px;
  margin: 10px 0 0;
  background: #fff7eb;
  border-radius: 9px;
  color: #8b6635;
  font-size: 12px;
  line-height: 1.45;
}
.business-page.staff-plans-page .staff-plan-days {
  margin-top: 10px;
  border-top: 1px solid #edf0f5;
}
.business-page.staff-plans-page .staff-plan-days > summary, .business-page.staff-plans-page .staff-plans-method > summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  min-height: 44px;
  box-sizing: border-box;
  list-style: none;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}
.business-page.staff-plans-page .staff-plan-days > summary::-webkit-details-marker, .business-page.staff-plans-page .staff-plans-method > summary::-webkit-details-marker {
  display: none;
}
.business-page.staff-plans-page .staff-plan-days > summary svg, .business-page.staff-plans-page .staff-plans-method > summary svg {
  width: 16px;
  height: 16px;
  flex: 0 0 16px;
  color: #78849a;
}
.business-page.staff-plans-page .staff-plan-days[open] > summary svg, .business-page.staff-plans-page .staff-plans-method[open] > summary svg {
  transform: rotate(180deg);
}
.business-page.staff-plans-page .staff-plans-day-table {
  width: 100%;
  table-layout: fixed;
}
.business-page.staff-plans-page .staff-plans-day-table .staff-plan-day-col {
  width: 32px;
}
.business-page.staff-plans-page .staff-plans-day-table .staff-plan-hours-col {
  width: 36px;
}
.business-page.staff-plans-page .staff-plans-day-table .staff-plan-action-col {
  width: 44px;
}
.business-page.staff-plans-page .staff-plans-day-table th, .business-page.staff-plans-page .staff-plans-day-table td {
  padding: 6px 4px;
  font-size: 12px;
  line-height: 1.4;
  text-align: right;
  vertical-align: middle;
  overflow-wrap: anywhere;
}
.business-page.staff-plans-page .staff-plans-day-table th {
  font-size: 10px;
  font-weight: 500;
  color: #78849a;
}
.business-page.staff-plans-page .staff-plans-day-table th:first-child, .business-page.staff-plans-page .staff-plans-day-table td:first-child {
  text-align: left;
  padding-left: 0;
}
.business-page.staff-plans-page .staff-plans-day-table td:first-child {
  font-weight: 500;
}
.business-page.staff-plans-page .staff-plans-day-table td {
  font-variant-numeric: tabular-nums;
}
.business-page.staff-plans-page .staff-plans-day-table small {
  display: block;
  font-size: 10px;
}
.business-page.staff-plans-page .staff-plans-day-table .staff-plan-day-action {
  padding: 4px 0;
}
.business-page.staff-plans-page .staff-plans-day-table .staff-plan-day-action .staff-plans-icon-button {
  border: 0;
  background: transparent;
}
.business-page.staff-plans-page .staff-plans-day-table tbody tr:last-child td {
  border-bottom: none;
}
.business-page.staff-plans-page .staff-plan-editor .staff-plan-editor-date {
  margin: 0 0 10px;
  font-size: 12px;
  color: #78849a;
}
.business-page.staff-plans-page .staff-plan-editor .staff-plan-amount {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  font-size: 13px;
}
.business-page.staff-plans-page .staff-plan-editor .staff-plan-amount input {
  flex: 1 1;
  min-width: 0;
  width: 100%;
  min-height: 44px;
  font-size: 16px;
  padding: 8px 10px;
}
.business-page.staff-plans-page .staff-plan-editor .staff-plan-editor-actions {
  display: flex;
  gap: 8px;
  margin: 10px 0;
}
.business-page.staff-plans-page .staff-plan-editor .staff-plan-editor-actions .business-primary {
  flex: 1 1;
}
.business-page.staff-plans-page .staff-plan-editor button {
  min-height: 44px;
  font-size: 13px;
  padding: 8px 12px;
}
.business-page.staff-plans-page .staff-plan-preview p {
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0;
}
.business-page.staff-plans-page .staff-plan-preview .business-toolbar {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 12px 0 0;
  gap: 8px;
}
.business-page.staff-plans-page .staff-plan-preview .business-toolbar button {
  font-size: 13px;
  padding: 8px 12px;
  min-height: 44px;
}
.business-page.staff-plans-page .staff-plan-preview .business-table th, .business-page.staff-plans-page .staff-plan-preview .business-table td {
  padding: 8px 6px;
  font-size: 12px;
}
.business-page.staff-plans-page .staff-plans-method {
  padding-block: 0;
}
.business-page.staff-plans-page .staff-plans-method > p {
  font-size: 12px;
  line-height: 1.5;
  margin: 8px 0 12px;
}
.business-page.staff-plans-page .business-notice, .business-page.staff-plans-page .business-error {
  padding: 10px 12px;
  margin: 8px 0;
  font-size: 13px;
  line-height: 1.45;
}
.business-page.staff-plans-page .business-error button {
  min-height: 44px;
  margin-left: 8px;
  padding: 8px 12px;
  border: none;
  border-radius: 10px;
  background: #fff;
  color: #a71b34;
  font-size: 13px;
}
@media (max-width: 650px) {
  .business-page.staff-plans-page {
    padding: 10px 10px 24px;
  }
  .business-page.staff-plans-page .staff-plans-period {
    margin-bottom: 10px;
  }
  .business-page.staff-plans-page .staff-plans-distribution button {
    width: 100%;
  }
  .business-page.staff-plans-page .staff-plans-distribution small {
    width: 100%;
  }
  .business-page.staff-plans-page .business-card {
    padding: 10px;
  }
  .business-page.staff-plans-page .staff-plan-heading {
    margin-bottom: 8px;
  }
  .business-page.staff-plans-page .staff-plan-heading h2 {
    font-size: 15px;
  }
  .business-page.staff-plans-page .business-metric {
    padding: 9px 8px;
  }
  .business-page.staff-plans-page .staff-plan-card .business-metric {
    padding: 0;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table tbody {
    gap: 6px;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table tr {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    padding: 8px;
    gap: 6px;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table td {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    font-size: 12px;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table td::before {
    font-size: 11px;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table td > span {
    text-align: left;
    font-variant-numeric: tabular-nums;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table td:first-child {
    grid-column: 1/-1;
    font-weight: 600;
  }
  .business-page.staff-plans-page .staff-plan-preview .mobile-card-table td:first-child::before {
    content: none;
  }
  .business-page.staff-plans-page .staff-plan-preview .business-toolbar button {
    width: auto;
  }
  .business-page.staff-plans-page .staff-plan-preview .business-toolbar .business-primary {
    flex: 1 1;
  }
  .business-page.staff-plans-page .staff-plan-preview .business-toolbar .business-secondary {
    flex: 0 0 auto;
  }
  .business-page.staff-plans-page .staff-plans-distribution-detail {
    display: none;
  }
  .business-page.staff-plans-page .staff-plans-method {
    padding-block: 0;
  }
}

.lkfr-app .business-page.staff-plans-page {
  max-width: 960px;
  margin-inline: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/StaffPlansPage/staffPlans.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,iBAAA;AACF;AAAE;EAAiB,eAAA;EAAiB,iBAAA;AAIpC;AAHE;EAAO,iCAAA;EAAmC,kBAAA;EAAoB,uBAAA;AAQhE;AAPE;EAAqB,aAAA;AAUvB;AATE;EAA2B,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,UAAA;EAAY,yBAAA;EAA2B,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;AAsB1N;AArBE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,mBAAA;AA2BtE;AA1BI;EAAQ,SAAA;EAAS,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,SAAA;EAAW,eAAA;EAAiB,cAAA;AAoCxH;AAnCI;EAAQ,SAAA;EAAS,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,sBAAA;EAAwB,eAAA;EAAiB,iBAAA;AA4C3G;AA1CE;EAAoB,aAAA;EAAe,gDAAA;EAAkD,QAAA;EAAU,gBAAA;AAgDjG;AA/CE;EAAmB,YAAA;EAAc,aAAA;EAAe,mBAAA;EAAqB,QAAA;AAqDvE;AApDI;EAAS,eAAA;EAAiB,gBAAA;AAwD9B;AAvDI;EAAW,mCAAA;EAAqC,gBAAA;EAAkB,uBAAA;EAAwB,kCAAA;EAAoC,uBAAA;AA8DlI;AA5DE;EAAuB,kBAAA;EAAoB,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AAkE9E;AAjEE;EAA4B,aAAA;EAAe,eAAA;EAAiB,mBAAA;EAAqB,aAAA;EAAe,mBAAA;AAwElG;AAvEI;EAAS,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AA4EhD;AA3EI;EAAQ,eAAA;EAAiB,gBAAA;AA+E7B;AA7EE;EAAiB,YAAA;EAAc,aAAA;EAAe,kBAAA;EAAoB,mBAAA;AAmFpE;AAlFE;EAAoB,eAAA;EAAiB,eAAA;EAAiB,iBAAA;EAAmB,uBAAA;AAwF3E;AAvFE;EAAsB,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,SAAA;EAAW,mBAAA;AA8FvG;AA7FI;EAAQ,YAAA;EAAc,SAAA;AAiG1B;AAhGI;EAAK,eAAA;EAAiB,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAsGrE;AArGI;EAAI,SAAA;EAAW,cAAA;EAAgB,eAAA;EAAiB,gBAAA;AA2GpD;AAzGE;EAAoC,UAAA;EAAY,YAAA;EAAc,gBAAA;EAAkB,gBAAA;AA+GlF;AA9GE;EAAkB,iBAAA;EAAmB,gBAAA;EAAkB,mBAAA;EAAqB,kBAAA;EAAoB,cAAA;EAAgB,eAAA;EAAiB,iBAAA;AAuHnI;AAtHE;EAAmB,gBAAA;EAAkB,6BAAA;AA0HvC;AAxHI;EAAY,aAAA;EAAe,mBAAA;EAAqB,8BAAA;EAAgC,QAAA;EAAU,gBAAA;EAAkB,sBAAA;EAAwB,gBAAA;EAAkB,eAAA;EAAiB,eAAA;EAAiB,gBAAA;AAoI5L;AAnIM;EAA4B,aAAA;AAsIlC;AArIM;EAAM,WAAA;EAAa,YAAA;EAAc,cAAA;EAAgB,cAAA;AA2IvD;AAzII;EAAwB,yBAAA;AA4I5B;AA1IE;EAAyB,WAAA;EAAa,mBAAA;AA8IxC;AA7II;EAAsB,WAAA;AAgJ1B;AA/II;EAAwB,WAAA;AAkJ5B;AAjJI;EAAyB,WAAA;AAoJ7B;AAnJI;EAAS,gBAAA;EAAkB,eAAA;EAAiB,gBAAA;EAAkB,iBAAA;EAAmB,sBAAA;EAAwB,uBAAA;AA2J7G;AA1JI;EAAK,eAAA;EAAiB,gBAAA;EAAkB,cAAA;AA+J5C;AA9JI;EAAiC,gBAAA;EAAkB,eAAA;AAkKvD;AAjKI;EAAiB,gBAAA;AAoKrB;AAnKI;EAAK,kCAAA;AAsKT;AArKI;EAAQ,cAAA;EAAgB,eAAA;AAyK5B;AAxKI;EAAyB,cAAA;AA2K7B;AA3K6C;EAA2B,SAAA;EAAW,uBAAA;AA+KnF;AA9KI;EAAyB,mBAAA;AAiL7B;AA9KI;EAA0B,gBAAA;EAAkB,eAAA;EAAiB,cAAA;AAmLjE;AAlLI;EAAqB,aAAA;EAAe,mBAAA;EAAqB,mBAAA;EAAqB,SAAA;EAAW,eAAA;AAyL7F;AAxLM;EAAQ,SAAA;EAAS,YAAA;EAAc,WAAA;EAAa,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AAgMrF;AA9LI;EAA6B,aAAA;EAAe,QAAA;EAAU,cAAA;AAmM1D;AAlMM;EAAoB,SAAA;AAqM1B;AAnMI;EAAS,gBAAA;EAAkB,eAAA;EAAiB,iBAAA;AAwMhD;AArMI;EAAI,eAAA;EAAiB,gBAAA;EAAkB,aAAA;AA0M3C;AAzMI;EAAoB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EAAiB,gBAAA;EAAkB,QAAA;AAgN/F;AAhNyG;EAAS,eAAA;EAAiB,iBAAA;EAAmB,gBAAA;AAqNtJ;AApNI;EAAyC,gBAAA;EAAkB,eAAA;AAwN/D;AAtNE;EAAsB,gBAAA;AAyNxB;AAxNI;EAAM,eAAA;EAAiB,gBAAA;EAAkB,kBAAA;AA6N7C;AA3NE;EAAoC,kBAAA;EAAoB,aAAA;EAAe,eAAA;EAAiB,iBAAA;AAiO1F;AAhOE;EAAyB,gBAAA;EAAkB,gBAAA;EAAkB,iBAAA;EAAmB,YAAA;EAAc,mBAAA;EAAqB,gBAAA;EAAkB,cAAA;EAAgB,eAAA;AA0OvJ;AAzOE;EACE;IAAI,uBAAA;EA4ON;EA3OE;IAAsB,mBAAA;EA8OxB;EA7O8B;IAAS,WAAA;EAgPvC;EAhPsD;IAAQ,WAAA;EAmP9D;EAlPE;IAAiB,aAAA;EAqPnB;EApPE;IAAsB,kBAAA;EAuPxB;EAvP4C;IAAK,eAAA;EA0PjD;EAzPE;IAAmB,gBAAA;EA4PrB;EA3PE;IAAoC,UAAA;EA8PtC;EA5PI;IAAQ,QAAA;EA+PZ;EA9PI;IAAK,gDAAA;IAAkD,YAAA;IAAc,QAAA;EAmQzE;EAlQI;IAAK,aAAA;IAAe,sBAAA;IAAwB,uBAAA;IAAyB,QAAA;IAAU,eAAA;EAyQnF;EAxQM;IAAY,eAAA;EA2QlB;EA1QM;IAAS,gBAAA;IAAkB,kCAAA;EA8QjC;EA7QM;IAAgB,iBAAA;IAAqB,gBAAA;EAiR3C;EAjR6D;IAAY,aAAA;EAoRzE;EAjR0C;IAAS,WAAA;EAoRnD;EApRkE;IAAoB,SAAA;EAuRtF;EAvRiG;IAAsB,cAAA;EA0RvH;EAzRE;IAAmC,aAAA;EA4RrC;EA3RE;IAAsB,gBAAA;EA8RxB;AACF;;AA5RA;EAA4C,gBAAA;EAAkB,mBAAA;AAiS9D","sourcesContent":[".business-page.staff-plans-page {\n  max-width: 960px;\n  padding-top: 12px;\n  .business-back { font-size: 12px; line-height: 18px; }\n  > h1 { font-size: clamp(23px, 4vw, 28px); margin: 8px 0 12px; letter-spacing: -.03em; }\n  .business-subtitle { display: none; }\n  .staff-plans-icon-button { display: inline-flex; align-items: center; justify-content: center; width: 44px; height: 44px; flex: 0 0 44px; padding: 0; border: 1px solid #e1e6ef; border-radius: 10px; background: #fff; color: #637089; }\n  .staff-plans-period { display: flex; align-items: center; gap: 8px; margin-bottom: 12px;\n    label { flex: 1; min-width: 0; display: flex; flex-direction: row; align-items: center; gap: 10px; font-size: 12px; color: #78849a; }\n    input { flex: 1; min-width: 0; width: 100%; min-height: 44px; box-sizing: border-box; font-size: 16px; padding: 8px 10px; }\n  }\n  .business-metrics { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; margin-bottom: 0; }\n  .business-metric { min-width: 0; padding: 10px; border-radius: 12px; gap: 5px;\n    > span { font-size: 11px; line-height: 1.3; }\n    > strong { font-size: clamp(16px, 2.6vw, 21px); line-height: 1.3; letter-spacing: -.03em; font-variant-numeric: tabular-nums; overflow-wrap: anywhere; }\n  }\n  .staff-plans-balance { margin: 6px 0 12px; color: #78849a; font-size: 11px; line-height: 1.4; }\n  .staff-plans-distribution { display: flex; flex-wrap: wrap; align-items: center; gap: 6px 12px; margin-bottom: 12px;\n    button { min-height: 44px; font-size: 13px; padding: 8px 12px; }\n    small { font-size: 11px; line-height: 1.4; }\n  }\n  .business-card { min-width: 0; padding: 12px; margin-bottom: 8px; border-radius: 14px; }\n  .business-card h2 { margin: 0 0 8px; font-size: 16px; line-height: 1.35; overflow-wrap: anywhere; }\n  .staff-plan-heading { display: flex; align-items: center; justify-content: space-between; gap: 10px; margin-bottom: 10px;\n    > div { min-width: 0; flex: 1; }\n    h2 { margin: 0 0 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n    p { margin: 0; color: #78849a; font-size: 11px; line-height: 1.4; }\n  }\n  .staff-plan-card .business-metric { padding: 0; border: none; border-radius: 0; background: none; }\n  .staff-plan-gap { padding: 8px 10px; margin: 10px 0 0; background: #fff7eb; border-radius: 9px; color: #8b6635; font-size: 12px; line-height: 1.45; }\n  .staff-plan-days { margin-top: 10px; border-top: 1px solid #edf0f5; }\n  .staff-plan-days, .staff-plans-method {\n    > summary { display: flex; align-items: center; justify-content: space-between; gap: 8px; min-height: 44px; box-sizing: border-box; list-style: none; cursor: pointer; font-size: 13px; font-weight: 500;\n      &::-webkit-details-marker { display: none; }\n      svg { width: 16px; height: 16px; flex: 0 0 16px; color: #78849a; }\n    }\n    &[open] > summary svg { transform: rotate(180deg); }\n  }\n  .staff-plans-day-table { width: 100%; table-layout: fixed;\n    .staff-plan-day-col { width: 32px; }\n    .staff-plan-hours-col { width: 36px; }\n    .staff-plan-action-col { width: 44px; }\n    th, td { padding: 6px 4px; font-size: 12px; line-height: 1.4; text-align: right; vertical-align: middle; overflow-wrap: anywhere; }\n    th { font-size: 10px; font-weight: 500; color: #78849a; }\n    th:first-child, td:first-child { text-align: left; padding-left: 0; }\n    td:first-child { font-weight: 500; }\n    td { font-variant-numeric: tabular-nums; }\n    small { display: block; font-size: 10px; }\n    .staff-plan-day-action { padding: 4px 0; .staff-plans-icon-button { border: 0; background: transparent; } }\n    tbody tr:last-child td { border-bottom: none; }\n  }\n  .staff-plan-editor {\n    .staff-plan-editor-date { margin: 0 0 10px; font-size: 12px; color: #78849a; }\n    .staff-plan-amount { display: flex; flex-direction: row; align-items: center; gap: 10px; font-size: 13px;\n      input { flex: 1; min-width: 0; width: 100%; min-height: 44px; font-size: 16px; padding: 8px 10px; }\n    }\n    .staff-plan-editor-actions { display: flex; gap: 8px; margin: 10px 0;\n      .business-primary { flex: 1; }\n    }\n    button { min-height: 44px; font-size: 13px; padding: 8px 12px; }\n  }\n  .staff-plan-preview {\n    p { font-size: 12px; line-height: 1.5; margin: 8px 0; }\n    .business-toolbar { display: flex; flex-direction: row; flex-wrap: wrap; margin: 12px 0 0; gap: 8px; button { font-size: 13px; padding: 8px 12px; min-height: 44px; } }\n    .business-table th, .business-table td { padding: 8px 6px; font-size: 12px; }\n  }\n  .staff-plans-method { padding-block: 0;\n    > p { font-size: 12px; line-height: 1.5; margin: 8px 0 12px; }\n  }\n  .business-notice, .business-error { padding: 10px 12px; margin: 8px 0; font-size: 13px; line-height: 1.45; }\n  .business-error button { min-height: 44px; margin-left: 8px; padding: 8px 12px; border: none; border-radius: 10px; background: #fff; color: #a71b34; font-size: 13px; }\n  @media (max-width: 650px) {\n    & { padding: 10px 10px 24px; }\n    .staff-plans-period { margin-bottom: 10px; }\n    .staff-plans-distribution { button { width: 100%; } small { width: 100%; } }\n    .business-card { padding: 10px; }\n    .staff-plan-heading { margin-bottom: 8px; h2 { font-size: 15px; } }\n    .business-metric { padding: 9px 8px; }\n    .staff-plan-card .business-metric { padding: 0; }\n    .staff-plan-preview .mobile-card-table {\n      tbody { gap: 6px; }\n      tr { grid-template-columns: repeat(2, minmax(0, 1fr)); padding: 8px; gap: 6px; }\n      td { display: flex; flex-direction: column; align-items: flex-start; gap: 2px; font-size: 12px;\n        &::before { font-size: 11px; }\n        > span { text-align: left; font-variant-numeric: tabular-nums; }\n        &:first-child { grid-column: 1 / -1; font-weight: 600; &::before { content: none; } }\n      }\n    }\n    .staff-plan-preview .business-toolbar { button { width: auto; } .business-primary { flex: 1; } .business-secondary { flex: 0 0 auto; } }\n    .staff-plans-distribution-detail { display: none; }\n    .staff-plans-method { padding-block: 0; }\n  }\n}\n.lkfr-app .business-page.staff-plans-page { max-width: 960px; margin-inline: auto; }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
